import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Check if a path is a dashboard path
export function isDashboardPath(path: string): boolean {
  return path.startsWith('/dashboard');
}

// Check if a user is authenticated and should see dashboard UI
export function shouldShowDashboardUI(isAuthenticated: boolean, path: string): boolean {
  return isAuthenticated && isDashboardPath(path);
}